import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    gap: '4rem',
  },
  title: {
    color: theme.palette.text.primary,
    textTransform: 'uppercase',
    fontSize: '20px',
    fontWeight: 900,
    marginBottom: '0.5rem',
  },
  text: {
    fontSize: '20px',
    maxWidth: '200px',
  },
}));

export default useStyles;
